import { useUpdateEffect } from 'react-use';

import { useFormController } from '@dreryk/react-common';
import { Toggle } from '@dreryk/react-components';

import { nfzSettingsTranslationKeys } from '../../../translations';

import { useCurrentHealthcareProviderEwusConfigurationSetCommand } from './NfzSettingsSaveAction.hooks';

type EwusIntegrationToggleProps = {
   readonly initialValue: boolean;
   readonly disabled: boolean;
};

export const EwusIntegrationToggle = (props: EwusIntegrationToggleProps): JSX.Element => {
   const { register, watch } = useFormController<{ value: boolean }>({ value: props.initialValue });

   const { executeAsync: setEwusConfiguration, loading } = useCurrentHealthcareProviderEwusConfigurationSetCommand();

   const currentValue = watch('value');

   useUpdateEffect(() => {
      setEwusConfiguration({
         enabled: currentValue,
      });
   }, [currentValue]);

   return (
      <Toggle
         controller={register('value')}
         label={nfzSettingsTranslationKeys.integrationWithEwusSystem}
         testId={'ewusIntegration'}
         disabled={props.disabled || loading}
         horizontal
      />
   );
};
